import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export type MasterDetailListWidth = "narrow" | "third";

export interface MasterDetailShellProps {
  list: ReactNode;
  detail: ReactNode;
  /**
   * List column width on large screens.
   * - `narrow` — fixed ~22rem list (transcripts, simple browsers)
   * - `third` — 3/12 grid (support chats and denser tools)
   */
  listWidth?: MasterDetailListWidth;
  className?: string;
  listClassName?: string;
  detailClassName?: string;
}

/** Shared list | detail split used by admin inbox-style pages. */
export function MasterDetailShell({
  list,
  detail,
  listWidth = "narrow",
  className,
  listClassName,
  detailClassName,
}: MasterDetailShellProps) {
  const third = listWidth === "third";

  return (
    <div
      className={cn(
        "grid min-h-0 flex-1 gap-4",
        third
          ? "grid-cols-1 lg:grid-cols-12 lg:items-stretch"
          : "lg:grid-cols-[minmax(0,22rem)_minmax(0,1fr)]",
        className,
      )}
    >
      <div
        className={cn(
          "flex min-h-0 flex-col",
          third && "lg:col-span-3",
          listClassName,
        )}
      >
        {list}
      </div>
      <div
        className={cn("min-h-0", third && "lg:col-span-9", detailClassName)}
      >
        {detail}
      </div>
    </div>
  );
}

/** Selectable row button styles for master-detail list panes. */
export function masterDetailListItemClass(selected: boolean): string {
  return cn(
    "flex w-full flex-col gap-1 px-4 py-3 text-left transition-colors",
    selected
      ? "bg-primary-50 dark:bg-primary-100/60"
      : "hover:bg-surface-50 dark:hover:bg-surface-100/50",
  );
}
